import { combineReducers } from "redux";
import { admin } from "./admin/reducer";
import { category } from "./category/reducer";
import { business } from "./business/reducer";
import { user } from "./user/reducer";
import { setting } from "./setting/reducer";
import { professional } from "./professional/reducer";
import { driver } from "./driver/reducer";
import { deliverySlice } from "../deliverySlice";
import { bookingSlice } from "./booking/bookingSlice";
import { reusableSlice } from "./reusable/reusableSlice";
import { Referaluser } from "./referals/reducer";

const reducers = combineReducers({
  user: user,
  setting: setting,
  professional: professional,
  driver: driver,
  category: category,
  admin: admin,
  business: business,
  Referaluser,
  deliverySlice: deliverySlice.reducer,
  bookingSlice:bookingSlice.reducer,
  reusableSlice:reusableSlice.reducer
});

export default reducers;
